import { components } from 'admin/schema/docs/api/admin';

type IndividualNumberIdentification = components['schemas']['IndividualNumberIdentification'];

// Display state for マイナンバー認証. The API returns validity (is_identified) and the
// 3-valued residency judgement (is_resident) as two orthogonal fields, so the single
// state the screens show is assembled here.
export const IDENTIFICATION_STATUS = {
  NOT_VERIFIED: 'not-verified',
  VERIFIED: 'verified',
  IS_RESIDENT: 'is-resident',
} as const;

export type IdentificationStatus =
  (typeof IDENTIFICATION_STATUS)[keyof typeof IDENTIFICATION_STATUS];

export const IDENTIFICATION_STATUS_LABELS: Record<IdentificationStatus, string> = {
  [IDENTIFICATION_STATUS.NOT_VERIFIED]: '認証なし',
  [IDENTIFICATION_STATUS.VERIFIED]: '認証済',
  [IDENTIFICATION_STATUS.IS_RESIDENT]: '住民認証済',
};

/**
 * Collapse a customer's マイナンバー認証 state into the single value the screens display.
 * Residency is checked first so that a record whose validity has expired while
 * is_resident is still set does not lose that distinction.
 */
export const identificationStatusOf = (
  identification?: Pick<IndividualNumberIdentification, 'is_identified' | 'is_resident'>
): IdentificationStatus => {
  // The residency judgement outlives expiry and keeps firing campaign is_resident
  // conditions. Checking is_identified first collapses that residue into 認証なし, which
  // makes the revocation target equal to the current value and therefore unselectable
  // (issue #7623).
  if (identification?.is_resident) return IDENTIFICATION_STATUS.IS_RESIDENT;
  if (identification?.is_identified) return IDENTIFICATION_STATUS.VERIFIED;
  return IDENTIFICATION_STATUS.NOT_VERIFIED;
};
